// src/layoutConfig.js

const getDefaultSaleDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 2);
    return date.toISOString().split("T")[0];
};

export const LAYOUT_CONFIG = {
    layout1: {
        defaultData: {
            camp_name: '',
            domain: 'https://www.nykaa.com/',
            brand_name: 'Nykaa',
            creative_name: 'Corkcicle Summer Review',
            canvas: {
                backgroundType: 'solid',
                backgroundColor: '#f1f1f1',
                textColor: '#121212',
                gradientColor1: '#f1f1f1',
                gradientColor2: '#ffffff',
                gradientAngle: 135,
                padding: '0px 30px',
            },
            video: {
                url: 'https://test-pages.b-cdn.net/SocialTV/nykaa.mp4',
                caption:
                    "What's the longest your ice has lasted in your Corkcicle? Let us know in the comments!",
                hashtags: '#Summer #ProductReview #Corkcicle',
                likes: '125',
                comments: '4',
                shares: '6',
                width: 100,
                height: 100,
                shadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                shape: 'none',
            },
            profile: {
                username: 'Nykaa',
                following: '29',
                followers: '43.5K',
                likes: '70.1K',
                bio: 'This year we celebrated Galentine’s by doing what we love most, getting fully glammed… just to stay in together. We dipped into our @charlottetilbury favourites (because obviously) and turned our living room into a full glam studio. Soft glam, good coffee, better gossip and no boys allowed.',
                brandTitle: 'Nykaa',
            },
            brand: {
                logoUrl:
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-IkLTc2M-yEOJxU7n5c1b3KZXA-r2w5ix3-9owQo&usqp=CAE&s',
                qrCodeUrl:
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s',
            },
            product: {
                name: 'Lipstick',
                price: '$4.95',
                rating: 5,
                imageUrl:
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSx0dT0QOJv6aYIE7RKqsMQz89uzWF9KdyAZg&s',
            },
        },
        validation: [
            { field: 'camp_name', errorKey: 'camp_name', required: true, message: 'Campaign name is required' },
            { field: 'brand_name', errorKey: 'brand_name', required: true, message: 'Brand name is required' },
            { field: 'domain', errorKey: 'domain', required: true, message: 'Domain is required' },
            { field: 'creative_name', errorKey: 'creative_name', required: true, message: 'Creative name is required' },
            {
                field: 'video.caption', errorKey: 'caption', required: true, minLength: 3, maxLength: 125, message: 'Caption must be 3–125 characters',
            },
            {
                field: 'profile.brandTitle',
                errorKey: 'brandTitle',
                required: true,
                minLength: 3,
                maxLength: 35,
                message: 'Brand title must be 3–35 characters',
            },
            {
                field: 'profile.bio',
                errorKey: 'bio',
                required: true,
                minLength: 100,
                maxLength: 300,
                message: 'Bio must be 100–300 characters',
            },
            {
                field: 'product.name',
                errorKey: 'name',
                required: true,
                minLength: 3,
                maxLength: 25,
                message: 'Product name must be 3–25 characters',
            },
        ],
        fields: [
            // ----- Basic Information -----
            {
                id: 'camp_name',
                label: 'Campaign Name',
                type: 'select',
                required: true,
                section: 'Basic Information',
                options: [], // populated from API later
            },
            {
                id: 'brand_name',
                label: 'Brand Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter brand name',
            },
            {
                id: 'domain',
                label: 'Domain',
                type: 'url',
                required: true,
                section: 'Basic Information',
                placeholder: 'https://example.com',
            },
            {
                id: 'creative_name',
                label: 'Creative Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter creative name',
            },

            // ----- Canvas Settings -----
            {
                id: 'canvas.backgroundType',
                label: 'Background Type',
                type: 'select',
                section: 'Canvas Settings',
                options: ['solid', 'gradient'],
                default: 'solid',
            },
            // Solid background (shown when backgroundType === 'solid')
            {
                id: 'canvas.backgroundColor',
                label: 'Background Color',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'solid' },
            },
            {
                id: 'canvas.textColor',
                label: 'Text Color',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'solid' },
            },
            // Gradient background (shown when backgroundType === 'gradient')
            {
                id: 'canvas.gradientColor1',
                label: 'Gradient Color 1',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            {
                id: 'canvas.gradientColor2',
                label: 'Gradient Color 2',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            // {
            //     id: 'canvas.gradientAngle',
            //     label: 'Gradient Angle (deg)',
            //     type: 'number',
            //     section: 'Canvas Settings',
            //     condition: { field: 'canvas.backgroundType', value: 'gradient' },
            //     placeholder: '135',
            // },
            // {
            //     id: 'canvas.padding',
            //     label: 'Padding (px)',
            //     type: 'text',
            //     section: 'Canvas Settings',
            //     placeholder: '0px 30px',
            // },

            // ----- Video & Caption -----
            {
                id: 'video.url',
                label: 'Video or Instagram URL',
                type: 'url',
                required: true,
                section: 'Video & Caption',
                placeholder: 'Enter video URL',
            },
            {
                id: 'video.caption',
                label: 'Caption',
                type: 'textarea',
                required: true,
                minLength: 3,
                maxLength: 125,
                section: 'Video & Caption',
                placeholder: 'Enter video caption',
            },
            {
                id: 'video.hashtags',
                label: 'Hashtags',
                type: 'text',
                section: 'Video & Caption',
                placeholder: '#hashtag1 #hashtag2',
            },
            {
                id: 'video.likes',
                label: 'Likes',
                type: 'text',
                maxLength: 5,
                section: 'Video & Caption',
                placeholder: '125',
            },
            {
                id: 'video.comments',
                label: 'Comments',
                type: 'text',
                maxLength: 5,
                section: 'Video & Caption',
                placeholder: '4',
            },
            {
                id: 'video.shares',
                label: 'Shares',
                type: 'text',
                maxLength: 5,
                section: 'Video & Caption',
                placeholder: '6',
            },

            // ----- Profile -----
            {
                id: 'brand.logoUrl',
                label: 'Brand Logo URL',
                type: 'url',
                section: 'Profile',
                placeholder: 'Enter logo image URL',
            },
            {
                id: 'profile.brandTitle',
                label: 'Brand Title',
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 35,
                section: 'Profile',
                placeholder: 'Enter brand title',
            },
            {
                id: 'profile.username',
                label: 'Username',
                type: 'text',
                section: 'Profile',
                placeholder: '@username',
            },
            {
                id: 'profile.following',
                label: 'Following',
                type: 'text',
                maxLength: 5,
                section: 'Profile',
                placeholder: '29',
            },
            {
                id: 'profile.followers',
                label: 'Followers',
                type: 'text',
                maxLength: 5,
                section: 'Profile',
                placeholder: '43.5K',
            },
            {
                id: 'profile.likes',
                label: 'Likes',
                type: 'text',
                maxLength: 5,
                section: 'Profile',
                placeholder: '70.1K',
            },
            {
                id: 'profile.bio',
                label: 'Bio',
                type: 'textarea',
                required: true,
                minLength: 100,
                maxLength: 300,
                section: 'Profile',
                placeholder: 'Enter profile bio',
                rows: 4,
            },

            // ----- Product -----
            {
                id: 'product.name',
                label: 'Product Name',
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 25,
                section: 'Product',
                placeholder: 'Product name',
            },
            {
                id: 'product.price',
                label: 'Price',
                type: 'text',
                section: 'Product',
                placeholder: '$0.00',
            },
            {
                id: 'product.rating',
                label: 'Rating (1-5)',
                type: 'number',
                section: 'Product',
                placeholder: '5',
                min: 1,
                max: 5,
            },
            {
                id: 'product.imageUrl',
                label: 'Product Image URL',
                type: 'url',
                section: 'Product',
                placeholder: 'Enter image URL',
            },
            {
                id: 'brand.qrCodeUrl',
                label: 'QR Code URL',
                type: 'url',
                section: 'Product',
                placeholder: 'Enter QR code URL',
            },
        ],
    },

    layout2: {
        defaultData: {
            camp_name: '',
            domain: 'https://www2.hm.com/',
            brand_name: 'H&M',
            creative_name: 'hm summer collection',
            canvas: {
                backgroundType: 'gradient',
                backgroundColor: '#4a735b',
                gradientColor1: '#4a735b',
                gradientColor2: '#33503e',
                gradientAngle: 135,
                padding: '0px',
            },
            video: {
                url: 'https://test-pages.b-cdn.net/SocialTV/h%26m.mp4',
                subtitle1: "Suit at the dentist's office?",
                subtitle2: 'Wear what makes you feel good.',
                width: 100,
                height: 100,
                shadow: '0 4px 10px rgba(0, 0, 0, 0.5)',
                shape: 'rounded',
                likes: '155',
                comments: '20',
                shares: '38',
            },
            brand: {
                logoUrl: 'https://i.ibb.co/9mmj4sZL/h-m-removebg-preview-white.png',
                website: 'hm.com',
                qrCodeUrl:
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s',
                shopText: 'Shop Now',
            },
            background: {
                backgroundType: 'solid',
                color: '#1a4d3a',
                gradientColor1: '#1a4d3a',
                gradientColor2: '#0b2b20',
                gradientAngle: 135,
            },
        },
        validation: [
            { field: 'camp_name', errorKey: 'camp_name', required: true, message: 'Campaign name is required' },
            { field: 'brand_name', errorKey: 'brand_name', required: true, message: 'Brand name is required' },
            { field: 'domain', errorKey: 'domain', required: true, message: 'Domain is required' },
            { field: 'creative_name', errorKey: 'creative_name', required: true, message: 'Creative name is required' },
            // Add any additional required fields from the form (if any) – e.g., video.url? Not sure, so we skip.
        ],
        fields: [
            {
                id: 'camp_name',
                label: 'Campaign Name',
                type: 'select',
                required: true,
                section: 'Basic Information',
                options: [], // populated from API later
            },
            {
                id: 'brand_name',
                label: 'Brand Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter brand name',
            },
            {
                id: 'domain',
                label: 'Domain',
                type: 'url',
                required: true,
                section: 'Basic Information',
                placeholder: 'https://example.com',
            },
            {
                id: 'creative_name',
                label: 'Creative Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter creative name',
            },

            // ----- Canvas Settings (for the main canvas) -----
            {
                id: 'canvas.backgroundType',
                label: 'Canvas Background Type',
                type: 'select',
                section: 'Canvas Settings',
                options: ['solid', 'gradient'],
                default: 'gradient',
            },
            // Solid background (if canvas.backgroundType === 'solid')
            {
                id: 'canvas.backgroundColor',
                label: 'Canvas Background Color',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'solid' },
            },
            // Gradient background (if canvas.backgroundType === 'gradient')
            {
                id: 'canvas.gradientColor1',
                label: 'Canvas Gradient Color 1',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            {
                id: 'canvas.gradientColor2',
                label: 'Canvas Gradient Color 2',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            // {
            //     id: 'canvas.gradientAngle',
            //     label: 'Canvas Gradient Angle (deg)',
            //     type: 'number',
            //     section: 'Canvas Settings',
            //     condition: { field: 'canvas.backgroundType', value: 'gradient' },
            //     placeholder: '135',
            // },
            // {
            //     id: 'canvas.padding',
            //     label: 'Canvas Padding (px)',
            //     type: 'text',
            //     section: 'Canvas Settings',
            //     placeholder: '0px',
            // },

            // ----- Video Settings -----
            {
                id: 'video.url',
                label: 'Video URL',
                type: 'url',
                section: 'Video Settings',
                placeholder: 'Enter video URL',
            },
            {
                id: 'video.subtitle1',
                label: 'Subtitle 1',
                type: 'text',
                section: 'Video Settings',
                placeholder: 'First subtitle',
            },
            {
                id: 'video.subtitle2',
                label: 'Subtitle 2',
                type: 'text',
                section: 'Video Settings',
                placeholder: 'Second subtitle',
            },
            {
                id: 'video.width',
                label: 'Width (%)',
                type: 'number',
                section: 'Video Settings',
                placeholder: '100',
                min: 10,
                max: 100,
            },
            {
                id: 'video.height',
                label: 'Height (%)',
                type: 'number',
                section: 'Video Settings',
                placeholder: '100',
                min: 10,
                max: 100,
            },
            {
                id: 'video.shadow',
                label: 'Shadow (CSS value)',
                type: 'text',
                section: 'Video Settings',
                placeholder: '0 4px 10px rgba(0,0,0,0.5)',
            },
            {
                id: 'video.shape',
                label: 'Video Shape',
                type: 'select',
                section: 'Video Settings',
                options: ['none', 'square', 'rounded', 'rounded-lg', 'circle'],
                default: 'rounded',
            },
            {
                id: 'video.likes',
                label: 'Likes',
                type: 'text',
                maxLength: 5,
                section: 'Video Settings',
                placeholder: '155',
            },
            {
                id: 'video.comments',
                label: 'Comments',
                type: 'text',
                maxLength: 5,
                section: 'Video Settings',
                placeholder: '20',
            },
            {
                id: 'video.shares',
                label: 'Shares',
                type: 'text',
                maxLength: 5,
                section: 'Video Settings',
                placeholder: '38',
            },

            // ----- Brand Information -----
            {
                id: 'brand.logoUrl',
                label: 'Brand Logo URL',
                type: 'url',
                section: 'Brand Information',
                placeholder: 'Enter logo URL',
            },
            {
                id: 'brand.website',
                label: 'Website',
                type: 'url',
                section: 'Brand Information',
                placeholder: 'hm.com',
            },
            {
                id: 'brand.shopText',
                label: 'Shop Button Text',
                type: 'text',
                section: 'Brand Information',
                placeholder: 'Shop Now',
            },
            {
                id: 'brand.qrCodeUrl',
                label: 'QR Code URL',
                type: 'url',
                section: 'Brand Information',
                placeholder: 'Enter QR code URL',
            },

            // ----- Background (separate from canvas) -----
            {
                id: 'background.backgroundType',
                label: 'Background Type (Separate)',
                type: 'select',
                section: 'Additional Background',
                options: ['solid', 'gradient'],
                default: 'solid',
            },
            // Solid background (if background.backgroundType === 'solid')
            {
                id: 'background.color',
                label: 'Background Color (Solid)',
                type: 'color',
                section: 'Additional Background',
                condition: { field: 'background.backgroundType', value: 'solid' },
            },
            // Gradient background (if background.backgroundType === 'gradient')
            {
                id: 'background.gradientColor1',
                label: 'Gradient Color 1',
                type: 'color',
                section: 'Additional Background',
                condition: { field: 'background.backgroundType', value: 'gradient' },
            },
            {
                id: 'background.gradientColor2',
                label: 'Gradient Color 2',
                type: 'color',
                section: 'Additional Background',
                condition: { field: 'background.backgroundType', value: 'gradient' },
            },
            // {
            //     id: 'background.gradientAngle',
            //     label: 'Gradient Angle (deg)',
            //     type: 'number',
            //     section: 'Additional Background',
            //     condition: { field: 'background.backgroundType', value: 'gradient' },
            //     placeholder: '135',
            // },
        ],
    },

    layout3: {
        defaultData: {
            camp_name: '',
            domain: 'https://www.ralphlauren.com/',
            brand_name: 'Ralph Lauren',
            creative_name: 'Ralph Lauren Summer Collection',
            canvas: {
                backgroundType: 'gradient',
                backgroundColor: '#042D44',
                gradientColor1: '#042D44',
                gradientColor2: '#1574C2',
                gradientAngle: 135,
                padding: '0px',
            },
            video: {
                url: 'https://test-pages.b-cdn.net/SocialTV/ralph_lauren.mp4',
            },
            brand: {
                name: 'Ralph Lauren',
                verified: true,
                followers: '331K',
                logoUrl: 'https://test-pages.b-cdn.net/SocialTV/ralph_lauren_logo.jpg',
                qrCodeUrl:
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s',
            },
            copy: {
                title: "Polo Ralph Lauren: Men's Outerwear",
                description:
                    'Rugged yet refined, #PoloRalphLauren leather and suede jackets are thoughtfully designed for durability and a timeless sartorial appeal.',
            },
            cta: {
                text: 'Shop Now',
                website: 'ralphlauren.com',
            },
        },
        validation: [
            { field: 'camp_name', errorKey: 'camp_name', required: true, message: 'Campaign name is required' },
            { field: 'brand_name', errorKey: 'brand_name', required: true, message: 'Brand name is required' },
            { field: 'domain', errorKey: 'domain', required: true, message: 'Domain is required' },
            { field: 'creative_name', errorKey: 'creative_name', required: true, message: 'Creative name is required' },
        ],
        fields: [
            // ----- Basic Information -----
            {
                id: 'camp_name',
                label: 'Campaign Name',
                type: 'select',
                required: true,
                section: 'Basic Information',
                options: [], // populated from API later
            },
            {
                id: 'brand_name',
                label: 'Brand Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter brand name',
            },
            {
                id: 'domain',
                label: 'Domain',
                type: 'url',
                required: true,
                section: 'Basic Information',
                placeholder: 'https://example.com',
            },
            {
                id: 'creative_name',
                label: 'Creative Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter creative name',
            },

            // ----- Canvas Settings -----
            {
                id: 'canvas.backgroundType',
                label: 'Background Type',
                type: 'select',
                section: 'Canvas Settings',
                options: ['solid', 'gradient'],
                default: 'gradient',
            },
            // Solid background (if backgroundType === 'solid')
            {
                id: 'canvas.backgroundColor',
                label: 'Background Color',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'solid' },
            },
            // Gradient background (if backgroundType === 'gradient')
            {
                id: 'canvas.gradientColor1',
                label: 'Gradient Color 1',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            {
                id: 'canvas.gradientColor2',
                label: 'Gradient Color 2',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            // {
            //     id: 'canvas.gradientAngle',
            //     label: 'Gradient Angle (deg)',
            //     type: 'number',
            //     section: 'Canvas Settings',
            //     condition: { field: 'canvas.backgroundType', value: 'gradient' },
            //     placeholder: '135',
            // },
            // {
            //     id: 'canvas.padding',
            //     label: 'Padding (px)',
            //     type: 'text',
            //     section: 'Canvas Settings',
            //     placeholder: '0px',
            // },

            // ----- Video -----
            {
                id: 'video.url',
                label: 'Video URL',
                type: 'url',
                section: 'Video',
                placeholder: 'Enter video URL',
            },

            // ----- Brand Information -----
            {
                id: 'brand.name',
                label: 'Brand Name (Display)',
                type: 'text',
                section: 'Brand Information',
                placeholder: 'Ralph Lauren',
            },
            {
                id: 'brand.followers',
                label: 'Followers',
                type: 'text',
                section: 'Brand Information',
                placeholder: '331K',
                maxLength: 10,
            },
            {
                id: 'brand.logoUrl',
                label: 'Brand Logo URL',
                type: 'url',
                section: 'Brand Information',
                placeholder: 'Enter logo URL',
            },
            {
                id: 'brand.qrCodeUrl',
                label: 'QR Code URL',
                type: 'url',
                section: 'Brand Information',
                placeholder: 'Enter QR code URL',
            },
            // (verified is boolean – could add a checkbox if needed, but we skip for simplicity)

            // ----- Copy -----
            {
                id: 'copy.title',
                label: 'Copy Title',
                type: 'text',
                section: 'Copy',
                placeholder: 'Enter title',
            },
            {
                id: 'copy.description',
                label: 'Copy Description',
                type: 'textarea',
                section: 'Copy',
                placeholder: 'Enter description',
                rows: 4,
            },

            // ----- CTA (Call to Action) -----
            {
                id: 'cta.text',
                label: 'CTA Button Text',
                type: 'text',
                section: 'Call to Action',
                placeholder: 'Shop Now',
            },
            {
                id: 'cta.website',
                label: 'CTA Website URL',
                type: 'url',
                section: 'Call to Action',
                placeholder: 'ralphlauren.com',
            },
        ],
    },

    layout4: {
        defaultData: {
            camp_name: '',
            domain: 'https://www.nykaa.com/',
            brand_name: 'Myntra',
            creative_name: 'Corkcicle Summer Review',
            canvas: {
                backgroundType: 'solid',
                gradientColor1: '#f1f1f1',
                gradientColor2: '#ffffff',
                gradientAngle: 135,
                bottomBackgroundColor: '#ffffff',
                sideBackgroundColor: '#d66700',
                titleTextColor: '#121212',
                subTitleTextColor: '#ffffff',
            },
            video: {
                url: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/layout4_input.mp4',
            },
            brand: {
                logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/logo.png',
                qrCodeUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/qr.png',
            },
            titles: [
                'Experience the difference',
                'Design for you',
                'Precision meets luxury',
            ], 
            subTitle: 'Crafted for those who value every second',
            products: [
                'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/product1.png',
                'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/product2.png',
                'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/product3.png',
            ],
        },
        validation: [
            { field: 'camp_name', required: true, message: 'Campaign name is required' },
            { field: 'brand_name', required: true, message: 'Brand name is required' },
            { field: 'domain', required: true, message: 'Domain is required' },
            { field: 'creative_name', required: true, message: 'Creative name is required' },
            // Add optional validations for arrays if needed (e.g., required? not specified)
        ],
        fields: [
            // ----- Basic Information -----
            {
                id: 'camp_name',
                label: 'Campaign Name',
                type: 'select',
                required: true,
                section: 'Basic Information',
                options: [], // populated from API later
            },
            {
                id: 'brand_name',
                label: 'Brand Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter brand name',
            },
            {
                id: 'domain',
                label: 'Domain',
                type: 'url',
                required: true,
                section: 'Basic Information',
                placeholder: 'https://example.com',
            },
            {
                id: 'creative_name',
                label: 'Creative Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter creative name',
            },

            // ----- Canvas Settings -----
            {
                id: 'canvas.backgroundType',
                label: 'Background Type',
                type: 'select',
                section: 'Canvas Settings',
                options: ['solid', 'gradient'],
                default: 'solid',
            },
            // Solid (shown when backgroundType === 'solid')
            {
                id: 'canvas.bottomBackgroundColor',
                label: 'Bottom Background Color',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'solid' },
            },
            {
                id: 'canvas.sideBackgroundColor',
                label: 'Side Background Color',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'solid' },
            },
            // Gradient (shown when backgroundType === 'gradient')
            {
                id: 'canvas.gradientColor1',
                label: 'Gradient Color 1',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            {
                id: 'canvas.gradientColor2',
                label: 'Gradient Color 2',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            // {
            //     id: 'canvas.gradientAngle',
            //     label: 'Gradient Angle (deg)',
            //     type: 'number',
            //     section: 'Canvas Settings',
            //     condition: { field: 'canvas.backgroundType', value: 'gradient' },
            //     placeholder: '135',
            // },
            // Text colors (always visible)
            {
                id: 'canvas.titleTextColor',
                label: 'Title Text Color',
                type: 'color',
                section: 'Canvas Settings',
            },
            {
                id: 'canvas.subTitleTextColor',
                label: 'Subtitle Text Color',
                type: 'color',
                section: 'Canvas Settings',
            },

            // ----- Video -----
            {
                id: 'video.url',
                label: 'Video URL',
                type: 'url',
                section: 'Video',
                placeholder: 'Enter video URL',
            },

            // ----- Brand -----
            {
                id: 'brand.logoUrl',
                label: 'Brand Logo URL',
                type: 'url',
                section: 'Brand',
                placeholder: 'Enter logo URL',
            },
            {
                id: 'brand.qrCodeUrl',
                label: 'QR Code URL',
                type: 'url',
                section: 'Brand',
                placeholder: 'Enter QR code URL',
            },

            // ----- Titles (array of 3) -----
            {
                id: 'titles[0]',
                label: 'Title 1',
                type: 'text',
                section: 'Titles',
                placeholder: 'First title',
            },
            {
                id: 'titles[1]',
                label: 'Title 2',
                type: 'text',
                section: 'Titles',
                placeholder: 'Second title',
            },
            {
                id: 'titles[2]',
                label: 'Title 3',
                type: 'text',
                section: 'Titles',
                placeholder: 'Third title',
            },

            // ----- Subtitle -----
            {
                id: 'subTitle',
                label: 'Subtitle',
                type: 'text',
                section: 'Subtitle',
                placeholder: 'Enter subtitle',
            },

            // ----- Products (array of 3 image URLs) -----
            {
                id: 'products[0]',
                label: 'Product Image 1 URL',
                type: 'url',
                section: 'Products',
                placeholder: 'Image URL 1',
            },
            {
                id: 'products[1]',
                label: 'Product Image 2 URL',
                type: 'url',
                section: 'Products',
                placeholder: 'Image URL 2',
            },
            {
                id: 'products[2]',
                label: 'Product Image 3 URL',
                type: 'url',
                section: 'Products',
                placeholder: 'Image URL 3',
            },
        ],
    },

    layout4C: {
        defaultData: {
            camp_name: '',
            domain: 'https://www.nykaa.com/',
            brand_name: 'Myntra',
            creative_name: 'Corkcicle Summer Review',
            saleDate: getDefaultSaleDate(),
            canvas: {
                backgroundType: 'gradient',
                backgroundColor: '#042D44',
                gradientColor1: '#ff24ce',
                gradientColor2: '#4111ca',
                gradientAngle: 90,
                padding: '0px',
                titleTextColor: '#ffffff',
                subTitleTextColor: '#ffffff',
            },
            video: {
                url: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/layout4_input.mp4',
            },
            brand: {
                logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/timer_logo.png',
            },
            title: 'INDIA BIGGEST BEAUTY SALE WITH THE BIGGEST BEAUTY SAVING',
            subTitle: 'GET THE BEST DEALS ON 1800+ BRANDS',
        },
        validation: [
            { field: 'camp_name', required: true, message: 'Campaign name is required' },
            { field: 'brand_name', required: true, message: 'Brand name is required' },
            { field: 'domain', required: true, message: 'Domain is required' },
            { field: 'creative_name', required: true, message: 'Creative name is required' },
            // Optionally validate saleDate is not empty
            { field: 'saleDate', required: true, message: 'Sale date is required' },
        ],
        fields: [
            {
                id: 'camp_name',
                label: 'Campaign Name',
                type: 'select',
                required: true,
                section: 'Basic Information',
                options: [], // populated from API later
            },
            {
                id: 'brand_name',
                label: 'Brand Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter brand name',
            },
            {
                id: 'domain',
                label: 'Domain',
                type: 'url',
                required: true,
                section: 'Basic Information',
                placeholder: 'https://example.com',
            },
            {
                id: 'creative_name',
                label: 'Creative Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter creative name',
            },
            {
                id: 'saleDate',
                label: 'Sale Date',
                type: 'date',
                required: true,
                section: 'Basic Information',
            },

            // ----- Canvas Settings -----
            {
                id: 'canvas.backgroundType',
                label: 'Background Type',
                type: 'select',
                section: 'Canvas Settings',
                options: ['solid', 'gradient'],
                default: 'gradient',
            },
            // Solid (shown when backgroundType === 'solid')
            {
                id: 'canvas.backgroundColor',
                label: 'Background Color',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'solid' },
            },
            // Gradient (shown when backgroundType === 'gradient')
            {
                id: 'canvas.gradientColor1',
                label: 'Gradient Color 1',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            {
                id: 'canvas.gradientColor2',
                label: 'Gradient Color 2',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            // {
            //     id: 'canvas.gradientAngle',
            //     label: 'Gradient Angle (deg)',
            //     type: 'number',
            //     section: 'Canvas Settings',
            //     condition: { field: 'canvas.backgroundType', value: 'gradient' },
            //     placeholder: '90',
            // },
            // {
            //     id: 'canvas.padding',
            //     label: 'Padding (px)',
            //     type: 'text',
            //     section: 'Canvas Settings',
            //     placeholder: '0px',
            // },
            // Text colors (always visible)
            {
                id: 'canvas.titleTextColor',
                label: 'Title Text Color',
                type: 'color',
                section: 'Canvas Settings',
            },
            {
                id: 'canvas.subTitleTextColor',
                label: 'Subtitle Text Color',
                type: 'color',
                section: 'Canvas Settings',
            },

            // ----- Video -----
            {
                id: 'video.url',
                label: 'Video URL',
                type: 'url',
                section: 'Video',
                placeholder: 'Enter video URL',
            },

            // ----- Brand -----
            {
                id: 'brand.logoUrl',
                label: 'Brand Logo URL',
                type: 'url',
                section: 'Brand',
                placeholder: 'Enter logo URL',
            },

            // ----- Main Title & Subtitle -----
            {
                id: 'title',
                label: 'Main Title',
                type: 'text',
                section: 'Title & Subtitle',
                placeholder: 'Enter main title',
            },
            {
                id: 'subTitle',
                label: 'Subtitle',
                type: 'text',
                section: 'Title & Subtitle',
                placeholder: 'Enter subtitle',
            },
        ],
    },

    layout5: {
        defaultData: {
            camp_name: '',
            domain: 'https://www.nykaa.com/',
            brand_name: 'Best4Run',
            creative_name: 'The Best Running Shoes',
            canvas: {
                backgroundColor: '#214F4F',
                gradientColor1: '#478cfe',
                gradientColor2: '#55e07b',
                textColor: '#ffffff',
                discountTextColor: '#ebed1e',
            },
            video: {
                url: 'https://test-pages.b-cdn.net/SocialTV/layout-5/layout5_input.mp4',
                url2: 'https://test-pages.b-cdn.net/SocialTV/layout-5/giphy.gif',
            },
            brand: {
                logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-5/best4run_logo.png',
                qrCodeUrl:
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s',
            },
            title: 'Give your wardrobe a spring refresh',
            discountText: 'Get 20% Off',
            infoText: 'All our models',
            products: [
                'https://test-pages.b-cdn.net/SocialTV/layout-5/shoe2.png',
                'https://test-pages.b-cdn.net/SocialTV/layout-5/shoe1.png',
            ],
        },
        validation: [
            { field: 'camp_name', required: true, message: 'Campaign name is required' },
            { field: 'brand_name', required: true, message: 'Brand name is required' },
            { field: 'domain', required: true, message: 'Domain is required' },
            { field: 'creative_name', required: true, message: 'Creative name is required' },
            // Optionally add validations for other fields (e.g., title, url) if needed
        ],
        fields: [
            // ----- Basic Information -----
            {
                id: 'camp_name',
                label: 'Campaign Name',
                type: 'select',
                required: true,
                section: 'Basic Information',
                options: [], // populated from API later
            },
            {
                id: 'brand_name',
                label: 'Brand Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter brand name',
            },
            {
                id: 'domain',
                label: 'Domain',
                type: 'url',
                required: true,
                section: 'Basic Information',
                placeholder: 'https://example.com',
            },
            {
                id: 'creative_name',
                label: 'Creative Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter creative name',
            },

            // ----- Canvas Settings -----
            {
                id: 'canvas.backgroundColor',
                label: 'Background Color',
                type: 'color',
                section: 'Canvas Settings',
            },
            {
                id: 'canvas.gradientColor1',
                label: 'Gradient Color 1',
                type: 'color',
                section: 'Canvas Settings',
            },
            {
                id: 'canvas.gradientColor2',
                label: 'Gradient Color 2',
                type: 'color',
                section: 'Canvas Settings',
            },
            {
                id: 'canvas.textColor',
                label: 'Text Color',
                type: 'color',
                section: 'Canvas Settings',
            },
            {
                id: 'canvas.discountTextColor',
                label: 'Discount Text Color',
                type: 'color',
                section: 'Canvas Settings',
            },

            // ----- Video -----
            {
                id: 'video.url',
                label: 'Main Video URL',
                type: 'url',
                section: 'Video',
                placeholder: 'Enter main video URL',
            },
            {
                id: 'video.url2',
                label: 'Secondary Video/GIF URL',
                type: 'url',
                section: 'Video',
                placeholder: 'Enter secondary video or GIF URL',
            },

            // ----- Brand -----
            {
                id: 'brand.logoUrl',
                label: 'Brand Logo URL',
                type: 'url',
                section: 'Brand',
                placeholder: 'Enter logo URL',
            },
            {
                id: 'brand.qrCodeUrl',
                label: 'QR Code URL',
                type: 'url',
                section: 'Brand',
                placeholder: 'Enter QR code URL',
            },

            // ----- Content -----
            {
                id: 'title',
                label: 'Main Title',
                type: 'text',
                section: 'Content',
                placeholder: 'Enter main title',
            },
            {
                id: 'discountText',
                label: 'Discount Text',
                type: 'text',
                section: 'Content',
                placeholder: 'e.g., Get 20% Off',
            },
            {
                id: 'infoText',
                label: 'Info Text',
                type: 'text',
                section: 'Content',
                placeholder: 'e.g., All our models',
            },

            // ----- Products (array of 2) -----
            {
                id: 'products[0]',
                label: 'Product Image 1 URL',
                type: 'url',
                section: 'Products',
                placeholder: 'Product 1 image URL',
            },
            {
                id: 'products[1]',
                label: 'Product Image 2 URL',
                type: 'url',
                section: 'Products',
                placeholder: 'Product 2 image URL',
            },
        ],
    },

    layout6: {
        defaultData: {
            camp_name: '',
            domain: 'https://www.nykaa.com/',
            brand_name: 'Myntra',
            creative_name: 'Corkcicle Summer Review',
            canvas: {
                backgroundColor: '#793b22',
                titleTextColor: '#ffffff',
                borderColor: '#cca884',
            },
            video: {
                url: 'https://test-pages.b-cdn.net/SocialTV/layout-6/video.webm',
            },
            brand: {
                logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-6/logo.png',
                qrCodeUrl:
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s',
            },
            title: 'Conquer Every Moment',
            product: 'https://test-pages.b-cdn.net/SocialTV/layout-6/product1.png?v123',
        },
        validation: [
            { field: 'camp_name', required: true, message: 'Campaign name is required' },
            { field: 'brand_name', required: true, message: 'Brand name is required' },
            { field: 'domain', required: true, message: 'Domain is required' },
            { field: 'creative_name', required: true, message: 'Creative name is required' },
        ],
        fields: [
            // ----- Basic Information -----
            {
                id: 'camp_name',
                label: 'Campaign Name',
                type: 'select',
                required: true,
                section: 'Basic Information',
                options: [], // populated from API later
            },
            {
                id: 'brand_name',
                label: 'Brand Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter brand name',
            },
            {
                id: 'domain',
                label: 'Domain',
                type: 'url',
                required: true,
                section: 'Basic Information',
                placeholder: 'https://example.com',
            },
            {
                id: 'creative_name',
                label: 'Creative Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter creative name',
            },

            // ----- Canvas Settings -----
            {
                id: 'canvas.backgroundColor',
                label: 'Background Color',
                type: 'color',
                section: 'Canvas Settings',
            },
            {
                id: 'canvas.titleTextColor',
                label: 'Title Text Color',
                type: 'color',
                section: 'Canvas Settings',
            },
            {
                id: 'canvas.borderColor',
                label: 'Border Color',
                type: 'color',
                section: 'Canvas Settings',
            },

            // ----- Video -----
            {
                id: 'video.url',
                label: 'Video URL',
                type: 'url',
                section: 'Video',
                placeholder: 'Enter video URL',
            },

            // ----- Brand -----
            {
                id: 'brand.logoUrl',
                label: 'Brand Logo URL',
                type: 'url',
                section: 'Brand',
                placeholder: 'Enter logo URL',
            },
            {
                id: 'brand.qrCodeUrl',
                label: 'QR Code URL',
                type: 'url',
                section: 'Brand',
                placeholder: 'Enter QR code URL',
            },

            // ----- Content -----
            {
                id: 'title',
                label: 'Main Title',
                type: 'text',
                section: 'Content',
                placeholder: 'Enter title',
            },
            {
                id: 'product',
                label: 'Product Image URL',
                type: 'url',
                section: 'Content',
                placeholder: 'Enter product image URL',
            },
        ],
    },

    layout7: {
        defaultData: {
            camp_name: '',
            domain: 'https://www.nykaa.com/',
            brand_name: 'Myntra',
            creative_name: 'Corkcicle Summer Review',
            canvas: {
                backgroundColor: '#214F4F',
                textColor: '#ffffff',
            },
            video: {
                url: 'https://test-pages.b-cdn.net/SocialTV/layout-7/video1.mp4',
            },
            brand: {
                logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-6/logo.png',
                qrCodeUrl:
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s',
            },
            title: 'Conquer Every Moment',
            infoText: 'Scan for 10% offer',
            products: [
                'https://test-pages.b-cdn.net/SocialTV/layout-7/product.png',
                'https://test-pages.b-cdn.net/SocialTV/layout-7/product1.png',
                'https://test-pages.b-cdn.net/SocialTV/layout-7/product2.png',
                'https://test-pages.b-cdn.net/SocialTV/layout-7/product3.png',
            ],
        },
        validation: [
            { field: 'camp_name', required: true, message: 'Campaign name is required' },
            { field: 'brand_name', required: true, message: 'Brand name is required' },
            { field: 'domain', required: true, message: 'Domain is required' },
            { field: 'creative_name', required: true, message: 'Creative name is required' },
        ],
        fields: [
            {
                id: 'camp_name',
                label: 'Campaign Name',
                type: 'select',
                required: true,
                section: 'Basic Information',
                options: [], // populated from API later
            },
            {
                id: 'brand_name',
                label: 'Brand Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter brand name',
            },
            {
                id: 'domain',
                label: 'Domain',
                type: 'url',
                required: true,
                section: 'Basic Information',
                placeholder: 'https://example.com',
            },
            {
                id: 'creative_name',
                label: 'Creative Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter creative name',
            },

            // ----- Canvas Settings -----
            {
                id: 'canvas.backgroundColor',
                label: 'Background Color',
                type: 'color',
                section: 'Canvas Settings',
            },
            {
                id: 'canvas.textColor',
                label: 'Text Color',
                type: 'color',
                section: 'Canvas Settings',
            },

            // ----- Video -----
            {
                id: 'video.url',
                label: 'Video URL',
                type: 'url',
                section: 'Video',
                placeholder: 'Enter video URL',
            },

            // ----- Brand -----
            {
                id: 'brand.logoUrl',
                label: 'Brand Logo URL',
                type: 'url',
                section: 'Brand',
                placeholder: 'Enter logo URL',
            },
            {
                id: 'brand.qrCodeUrl',
                label: 'QR Code URL',
                type: 'url',
                section: 'Brand',
                placeholder: 'Enter QR code URL',
            },

            // ----- Content -----
            {
                id: 'title',
                label: 'Main Title',
                type: 'text',
                section: 'Content',
                placeholder: 'Enter title',
            },
            {
                id: 'infoText',
                label: 'Info Text',
                type: 'text',
                section: 'Content',
                placeholder: 'e.g., Scan for 10% offer',
            },

            // ----- Products (array of 4) -----
            {
                id: 'products[0]',
                label: 'Product Image 1 URL',
                type: 'url',
                section: 'Products',
                placeholder: 'Product 1 URL',
            },
            {
                id: 'products[1]',
                label: 'Product Image 2 URL',
                type: 'url',
                section: 'Products',
                placeholder: 'Product 2 URL',
            },
            {
                id: 'products[2]',
                label: 'Product Image 3 URL',
                type: 'url',
                section: 'Products',
                placeholder: 'Product 3 URL',
            },
            {
                id: 'products[3]',
                label: 'Product Image 4 URL',
                type: 'url',
                section: 'Products',
                placeholder: 'Product 4 URL',
            },
        ],
    },

    layout8: {
        defaultData: {
            camp_name: '',
            domain: 'https://pocomico.com/',
            brand_name: 'pocomico',
            creative_name: 'pocomico_July',
            canvas: {
                backgroundType: 'gradient',
                backgroundColor: '#BAB8B3',
                gradientColor1: '#BAB8B3',
                gradientColor2: '#5F594D',
                gradientAngle: 135,
                padding: '0px',
            },
            video: {
                url: 'https://vast.jambojar.com/SocialTV/pocomico_video_20sec.mp4',
            },
            brand: {
                name: 'Pocomico',
                verified: true,
                followers: '5K',
                logoUrl: 'https://vast.jambojar.com/SocialTV/pocomico_logo_200.png',
                qrCodeUrl: 'https://vast.jambojar.com/SocialTV/pocomico_QR.png',
            },
            copy: {
                title: 'Find Your Perfect Festive Outfit',
                description:
                    'Discover elegant Indian wear and cozy winter styles designed to make every celebration special. Refresh your wardrobe with timeless festive fashion.',
            },
            cta: {
                text: 'Shop Now',
                website: 'pocomico.com',
            },
        },
        validation: [
            { field: 'camp_name', required: true, message: 'Campaign name is required' },
            { field: 'brand_name', required: true, message: 'Brand name is required' },
            { field: 'domain', required: true, message: 'Domain is required' },
            { field: 'creative_name', required: true, message: 'Creative name is required' },
        ],
        fields: [
            // ----- Basic Information -----
            {
                id: 'camp_name',
                label: 'Campaign Name',
                type: 'select',
                required: true,
                section: 'Basic Information',
                options: [], // populated from API later
            },
            {
                id: 'brand_name',
                label: 'Brand Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter brand name',
            },
            {
                id: 'domain',
                label: 'Domain',
                type: 'url',
                required: true,
                section: 'Basic Information',
                placeholder: 'https://example.com',
            },
            {
                id: 'creative_name',
                label: 'Creative Name',
                type: 'text',
                required: true,
                section: 'Basic Information',
                placeholder: 'Enter creative name',
            },

            // ----- Canvas Settings -----
            {
                id: 'canvas.backgroundType',
                label: 'Background Type',
                type: 'select',
                section: 'Canvas Settings',
                options: ['solid', 'gradient'],
                default: 'gradient',
            },
            // Solid (shown when backgroundType === 'solid')
            {
                id: 'canvas.backgroundColor',
                label: 'Background Color',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'solid' },
            },
            // Gradient (shown when backgroundType === 'gradient')
            {
                id: 'canvas.gradientColor1',
                label: 'Gradient Color 1',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            {
                id: 'canvas.gradientColor2',
                label: 'Gradient Color 2',
                type: 'color',
                section: 'Canvas Settings',
                condition: { field: 'canvas.backgroundType', value: 'gradient' },
            },
            // {
            //     id: 'canvas.gradientAngle',
            //     label: 'Gradient Angle (deg)',
            //     type: 'number',
            //     section: 'Canvas Settings',
            //     condition: { field: 'canvas.backgroundType', value: 'gradient' },
            //     placeholder: '135',
            // },
            // {
            //     id: 'canvas.padding',
            //     label: 'Padding (px)',
            //     type: 'text',
            //     section: 'Canvas Settings',
            //     placeholder: '0px',
            // },

            // ----- Video -----
            {
                id: 'video.url',
                label: 'Video URL',
                type: 'url',
                section: 'Video',
                placeholder: 'Enter video URL',
            },

            // ----- Brand Information -----
            {
                id: 'brand.name',
                label: 'Brand Display Name',
                type: 'text',
                section: 'Brand Information',
                placeholder: 'Pocomico',
            },
            {
                id: 'brand.followers',
                label: 'Followers Count',
                type: 'text',
                section: 'Brand Information',
                placeholder: '5K',
                maxLength: 10,
            },
            {
                id: 'brand.logoUrl',
                label: 'Brand Logo URL',
                type: 'url',
                section: 'Brand Information',
                placeholder: 'Enter logo URL',
            },
            {
                id: 'brand.qrCodeUrl',
                label: 'QR Code URL',
                type: 'url',
                section: 'Brand Information',
                placeholder: 'Enter QR code URL',
            },
            // Note: verified is a boolean; if needed, add a checkbox – we skip it here for simplicity

            // ----- Copy -----
            {
                id: 'copy.title',
                label: 'Copy Title',
                type: 'text',
                section: 'Copy',
                placeholder: 'Enter title',
            },
            {
                id: 'copy.description',
                label: 'Copy Description',
                type: 'textarea',
                section: 'Copy',
                placeholder: 'Enter description',
                rows: 4,
            },

            // ----- CTA (Call to Action) -----
            {
                id: 'cta.text',
                label: 'CTA Button Text',
                type: 'text',
                section: 'Call to Action',
                placeholder: 'Shop Now',
            },
            {
                id: 'cta.website',
                label: 'CTA Website URL',
                type: 'url',
                section: 'Call to Action',
                placeholder: 'pocomico.com',
            },
        ],
    },
};